/* eslint-disable no-undef */
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import * as msal from '@azure/msal-browser';

import { getMicrosoftUserInfoApi, microsoftUserCreateApi, microsoftUserGroupApi } from './api';
import { createSession } from './authenticationService';

// msal client options
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
        scope: process.env.REACT_APP_SCOPE,
    },
};

// msal client object configured
const msalInstance = new msal.PublicClientApplication(msalConfig);


// microsoft redirect callback function
msalInstance.handleRedirectPromise().then(async (response) => {
    if(response !== null && response !== undefined) {
        console.log(response);
        const userInfo = await getMicrosoftUserInfoApi(response.accessToken); // microsoft graph api for getting user information
        console.log(userInfo);

        let role = 'Viewer'; // for temporary role set to admin after checking we can again set role="PM"
        let isAdmin = false; //for temporary admin role isAdmin value should be true
        
        const groupsIds = await microsoftUserGroupApi(response.accessToken);   // microsoft graph api to get ids of user groups
        console.log(groupsIds);
        for (const id of groupsIds.value) {
            if (id === 'd96e7d24-9a85-4fa2-9d91-db63db5c5628') {
                role = 'Admin';
                isAdmin = true;
                break;
            }
        }

        Cookies.set('wpm-lightpole-token', response.accessToken, { expires: 30 });
        console.log(userInfo.mail, userInfo.displayName, isAdmin);
        
        const rs = await microsoftUserCreateApi(userInfo.mail, userInfo.displayName, isAdmin); // create user API when user not not found. 
        createSession(rs.token, rs.fullUsername, role, userInfo.mail, rs.userId);

        localStorage.removeItem('microsoftLogin');
        window.location.reload();
    } else {
        localStorage.removeItem('microsoftLogin');
    }
}).catch(error => {
    localStorage.removeItem('microsoftLogin');
    toast.error(error.toString());
});

export default msalInstance;
